<template>
    <div class="error_message_container" :class="{'isBE' : isBE }">
        <p v-show="discPriceErrorShouldShow" class="discount-code-error"><font-awesome-icon icon="info-circle" /><span style="padding-left:5px">{{strings.no_rooms_with_discount_code}}</span></p>
        <!-- Error message for FK wl -->
        <p v-if="fkDelegatesErrorShouldShow" class="fk_error">
            <font-awesome-icon icon="info-circle" />
            <span style="padding-left:5px">{{strings.fkDelegatesError}}</span>
            <a href="https://www.delegia.com/app/attendee/new_registration.asp?PROJECTID=10996&CLEAR=yes%C2%AELINENO=1%C2%AELINEID=53661&EDIT=off%C2%AELINEPAGENO=1" target="_blank">
                MRF LINK
            </a>
        </p>
    </div>
</template>

<script>
import Vue from 'vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faInfoCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
    computed: {
        isBE() {
            return this.$store.state.isBE;
        },
        strings() {
            return this.$store.state.strings;
        },
        discPriceErrorShouldShow() {
            return this.$store.state.discPriceErrorShouldShow && (this.$store.state.packagesLoaded == true || this.$store.state.roomsLoaded == true || this.$store.state.useNewCheckoutPage);
        },
        fkDelegatesErrorShouldShow() {
            return this.$store.state.fkDelegatesErrorShouldShow
        }
    }

}
</script>

<style scoped>
    .error_message_container{
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
    .discount-code-block p {
        color: black;
        font-style: italic;
    }
    .discount-code-wrapper .v-spinner{
        float:none;
    }
    .discount-code-wrapper button{
        max-height:40px;
    }
    .discount-code-wrapper .v-pulse{
        width:14px!important;
        height: 14px!important;
    }
    .discount-code-block .helptext{
        margin-bottom: 0px;
        font-size: 12px;
        padding-left: 5px;
            font-style: normal;
    }
    .discount-code-wrapper{
        margin-left:5px;
    }
    .discount-code-error{
        color:red;
    }
    .isBE .discount-code-error{
        margin: 0;
    }
    .fk_error,
    .fk_error a {
        color: red !important;
    }
</style>
